/* ICT tools page: Build your PC, Gaming PC, UPS runtime and Solar & battery calculators.
   Markup: sections/ict-tools.liquid. Parts come from sections/ict-tools-products (JSON) via the
   Section Rendering API using each slot's search query. Tabs deep-link with #pc #gaming #ups #solar #storage. */
(function () {
  var root = document.querySelector('ict-tools');
  if (!root) return;

  var config = JSON.parse(root.querySelector('[data-config]').textContent);
  var searchUrl = root.dataset.searchUrl || '/search';
  var cartUrl = (root.dataset.cart || '/cart').replace(/\/$/, '');
  var moneyFormat = root.dataset.moneyFormat || 'K{{amount_no_decimals}}';
  var STORE_KEY = 'ict.tools.build.';
  var DESCRIPTIONS = {
    pc: 'Pick compatible parts for work, study and everyday use. Prices and stock are live.',
    gaming: 'Performance parts plus a gaming monitor, chair and accessories for your setup.'
  };

  var state = { tab: 'pc', builds: { pc: load('pc'), gaming: load('gaming') }, slot: null, products: [], brand: '' };

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }

  function money(cents) {
    var value = cents / 100;
    function fmt(d, t, s) { var p = value.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(s); }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return fmt(0, ',', '.');
      if (k === 'amount_with_comma_separator') return fmt(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(0, '.', ',');
      return fmt(2, ',', '.');
    });
  }
  function load(mode) { try { return JSON.parse(localStorage.getItem(STORE_KEY + mode) || '{}'); } catch (e) { return {}; } }
  function save(mode) { try { localStorage.setItem(STORE_KEY + mode, JSON.stringify(state.builds[mode])); } catch (e) {} }

  /* ---------- Tabs ---------- */
  function setTab(tab, push) {
    if (['pc', 'gaming', 'ups', 'solar', 'storage'].indexOf(tab) < 0) tab = 'pc';
    state.tab = tab;
    $$('[data-tab]').forEach(function (b) { b.setAttribute('aria-selected', String(b.dataset.tab === tab)); });
    var isBuilder = tab === 'pc' || tab === 'gaming';
    $('[data-panel="builder"]').hidden = !isBuilder;
    $('[data-panel="ups"]').hidden = tab !== 'ups';
    $('[data-panel="solar"]').hidden = tab !== 'solar';
    $('[data-panel="storage"]').hidden = tab !== 'storage';
    root.dataset.activeTab = tab;
    if (isBuilder) renderBuilder();
    if (tab === 'ups') calcUps();
    if (tab === 'solar') calcSolar();
    if (tab === 'storage') calcStorage();
    if (push !== false && location.hash.slice(1).split('=')[0] !== tab) history.replaceState(null, '', '#' + tab);
  }

  /* ---------- Builder ---------- */
  function slots() { return config[state.tab]; }
  function build() { return state.builds[state.tab]; }

  var ICONS = {
    chip: '<rect x="6" y="6" width="12" height="12" rx="2"/><path d="M9 2v4m6-4v4M9 18v4m6-4v4M2 9h4m-4 6h4m12-6h4m-4 6h4"/><rect x="9" y="9" width="6" height="6"/>',
    board: '<rect x="3" y="3" width="18" height="18" rx="2"/><path d="M7 7h4v4H7zM15 7h2M15 11h2M7 15h10"/>',
    memory: '<rect x="2" y="7" width="20" height="9" rx="1"/><path d="M6 16v3m4-3v3m4-3v3m4-3v3M6 10h2m3 0h2m3 0h2"/>',
    storage: '<ellipse cx="12" cy="6" rx="8" ry="3"/><path d="M4 6v12c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3"/>',
    gpu: '<rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="9" cy="12" r="3"/><path d="M15 10h4m-4 4h4"/>',
    'case': '<rect x="6" y="2" width="12" height="20" rx="2"/><circle cx="12" cy="15" r="3"/><path d="M9 6h6"/>',
    power: '<path d="m13 2-8 12h6l-1 8 8-12h-6Z"/>',
    fan: '<circle cx="12" cy="12" r="2"/><path d="M12 10c0-4 1-7 4-7s3 4-1 6m-3 3c4 0 7 1 7 4s-4 3-6-1m-3-3c0 4-1 7-4 7s-3-4 1-6m3-3c-4 0-7-1-7-4s4-3 6 1"/>',
    monitor: '<rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8m-4-4v4"/>',
    chair: '<path d="M7 3h10v9H7zM5 12h14M8 12l-2 9m10-9 2 9M12 12v6"/>',
    keyboard: '<rect x="2" y="6" width="20" height="12" rx="2"/><path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M7 14h10"/>',
    mouse: '<rect x="6" y="3" width="12" height="18" rx="6"/><path d="M12 7v4"/>',
    headset: '<path d="M3 14v-2a9 9 0 0 1 18 0v2"/><rect x="3" y="13" width="4" height="7" rx="2"/><rect x="17" y="13" width="4" height="7" rx="2"/>'
  };
  function icon(name) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + (ICONS[name] || ICONS.chip) + '</svg>'; }

  function renderBuilder() {
    var mode = state.tab;
    $('[data-builder-title]').textContent = mode === 'gaming' ? 'Build your gaming PC' : 'Build your PC';
    $('[data-builder-desc]').textContent = DESCRIPTIONS[mode];
    var list = $('[data-slots]');
    list.replaceChildren();
    slots().forEach(function (slot, index) {
      var picked = build()[slot.id];
      var li = el('li', 'ict-tb__slot' + (picked ? ' is-picked' : ''));
      var ic = el('span', 'ict-tb__icon');
      ic.innerHTML = icon(slot.icon);
      li.append(ic);
      var body = el('div', 'ict-tb__body');
      body.append(el('span', 'ict-tb__step', String(index + 1).padStart(2, '0') + (slot.core === false ? ' · Optional' : '')));
      body.append(el('strong', 'ict-tb__name', slot.label));
      if (picked) {
        var item = el('a', 'ict-tb__pick');
        item.href = picked.url;
        item.target = '_blank';
        item.rel = 'noopener';
        if (picked.image) { var img = el('img'); img.src = picked.image; img.alt = ''; img.loading = 'lazy'; item.append(img); }
        var t = el('span', 'ict-tb__pick-text');
        t.append(el('span', 'ict-tb__pick-title', picked.title));
        t.append(el('span', 'ict-tb__pick-price', money(picked.price)));
        item.append(t);
        body.append(item);
      }
      li.append(body);
      var actions = el('div', 'ict-tb__actions');
      var choose = el('button', 'ict-tb__choose' + (picked ? ' is-change' : ''));
      choose.innerHTML = picked ? '<span class="ict-tb__choose-text">Change</span>' : '<span aria-hidden="true">+</span><span class="ict-tb__choose-text">Choose</span>';
      choose.setAttribute('aria-label', (picked ? 'Change ' : 'Choose ') + slot.label.toLowerCase());
      choose.type = 'button';
      choose.dataset.choose = slot.id;
      actions.append(choose);
      if (picked) {
        var remove = el('button', 'ict-tb__remove', '×');
        remove.type = 'button';
        remove.dataset.remove = slot.id;
        remove.setAttribute('aria-label', 'Remove ' + slot.label);
        actions.append(remove);
      }
      li.append(actions);
      list.append(li);
    });
    renderSummary();
  }

  function platform(text) {
    text = (text || '').toLowerCase();
    if (/intel|core i\d|core ultra|lga ?1[278]\d\d|\b(h510|h610|h670|h770|h810|b460|b560|b660|b760|b860|z490|z590|z690|z790|z890)\w*\b/.test(text)) return 'Intel';
    if (/\bamd\b|ryzen|athlon|\bam[45]\b|\b(a320|a520|a620|b350|b450|b550|b650|b850|x370|x470|x570|x670|x870)\w*\b/.test(text)) return 'AMD';
    return '';
  }
  function socket(text) {
    text = (text || '').toLowerCase();
    if (/am5|\b(a620|b650|b850|x670|x870)|ryzen \d\s?(7|8|9)\d{3}|\br\d-?(7|8|9)\d{3}/.test(text)) return 'AM5';
    if (/am4|\b(a320|a520|b350|b450|b550|x370|x470|x570)|ryzen \d\s?[1-5]\d{3}|\br\d-?[1-5]\d{3}|athlon 3000/.test(text)) return 'AM4';
    if (/lga ?1851|\b(b860|z890|h810)|ultra \d.*\b2\d{2}[a-z]*\b/.test(text)) return 'LGA1851';
    if (/lga ?1700|\b(h610|b660|h670|z690|b760|h770|z790)|\b1[234]\d{3}[a-z]*\b/.test(text)) return 'LGA1700';
    if (/lga ?1200|\b(h510|b460|b560|h470|z490|z590)|\b1[01]\d{3}[a-z]*\b/.test(text)) return 'LGA1200';
    return '';
  }
  function ddr(text) { var m = (text || '').match(/ddr\s?([45])/i); return m ? 'DDR' + m[1] : ''; }
  function psuWatts(text) { var m = (text || '').match(/(\d{3,4})\s?w\b/i); return m ? Number(m[1]) : 0; }
  function cpuWatts(t) {
    t = t.toLowerCase();
    if (/i9|ryzen 9|ultra 9/.test(t)) return 170;
    if (/i7|ryzen 7|ultra 7/.test(t)) return 125;
    if (/i5|ryzen 5|ultra 5/.test(t)) return 95;
    return 65;
  }
  function gpuWatts(t) {
    t = t.toLowerCase();
    var table = [[/[45]090/, 450], [/[45]080/, 320], [/[45]070 ti/, 285], [/[45]070/, 220], [/[45]060 ti/, 165], [/[45]060/, 140], [/3080/, 320], [/3070/, 220], [/3060/, 170], [/3050/, 130], [/1650|1630|1030|710|730/, 75], [/7900/, 330], [/7800|9070/, 260], [/7700/, 245], [/7600|9060/, 165], [/6600/, 132], [/6500|6400/, 107]];
    for (var i = 0; i < table.length; i++) if (table[i][0].test(t)) return table[i][1];
    return 200;
  }

  function renderSummary() {
    var b = build();
    var core = slots().filter(function (s) { return s.core !== false; });
    var all = slots();
    var picked = all.filter(function (s) { return b[s.id]; });
    var total = picked.reduce(function (sum, s) { return sum + b[s.id].price; }, 0);
    $('[data-sum-label]').textContent = state.tab === 'gaming' ? 'Gaming setup' : 'Your build';
    $('[data-total]').textContent = money(total);
    var coreDone = core.filter(function (s) { return b[s.id]; }).length;
    $('[data-progress]').style.width = Math.round((picked.length / all.length) * 100) + '%';
    $('[data-count]').textContent = picked.length + ' of ' + all.length + ' items' + (core.length !== all.length ? ' · ' + coreDone + '/' + core.length + ' core parts' : '');

    var watts = 0;
    if (b.cpu) watts += cpuWatts(b.cpu.title);
    if (b.graphics) watts += gpuWatts(b.graphics.title);
    if (b.motherboard) watts += 50;
    if (b.memory) watts += 10;
    if (b.storage) watts += 8;
    if (b.cooling) watts += 10;
    if (watts) watts += 25;
    var psu = watts ? Math.ceil((watts * 1.4) / 50) * 50 : 0;
    root.dataset.loadWatts = watts || '';
    $('[data-watts]').textContent = watts ? '≈ ' + watts + ' W' : '–';
    $('[data-psu]').textContent = psu ? psu + ' W+' : '–';

    var checks = [];
    var cpuP = b.cpu ? platform(b.cpu.title + ' ' + b.cpu.type) : '';
    var mbP = b.motherboard ? platform(b.motherboard.title + ' ' + b.motherboard.type) : '';
    var cpuS = b.cpu ? socket(b.cpu.title + ' ' + b.cpu.type) : '';
    var mbS = b.motherboard ? socket(b.motherboard.title + ' ' + b.motherboard.type) : '';
    if (cpuS && mbS) checks.push(cpuS === mbS ? ['ok', cpuS + ' processor and motherboard match'] : ['warn', 'Processor is ' + cpuS + ' but the motherboard is ' + mbS + ' — they won\'t fit together']);
    else if (cpuP && mbP) checks.push(cpuP === mbP ? ['ok', cpuP + ' processor matches the motherboard'] : ['warn', cpuP + ' processor needs an ' + cpuP + ' motherboard — this board looks ' + mbP]);
    var mbD = b.motherboard ? ddr(b.motherboard.title) : '';
    var memD = b.memory ? ddr(b.memory.title) : '';
    if (mbD && memD) checks.push(mbD === memD ? ['ok', memD + ' memory matches the motherboard'] : ['warn', 'Motherboard uses ' + mbD + ' but the memory is ' + memD]);
    var pw = b.power ? psuWatts(b.power.title) : 0;
    if (pw && psu) checks.push(pw >= psu ? ['ok', pw + ' W power supply covers this build'] : ['warn', pw + ' W power supply may be too small — aim for ' + psu + ' W or more']);
    if (!checks.length) checks.push(['info', 'Compatibility checks appear as you add parts']);
    var ul = $('[data-checks]');
    ul.replaceChildren();
    checks.forEach(function (c) { ul.append(el('li', 'is-' + c[0], c[1])); });

    $('[data-add]').disabled = !picked.length;
    $('[data-add]').textContent = picked.length ? 'Add ' + picked.length + ' item' + (picked.length > 1 ? 's' : '') + ' to cart' : 'Add build to cart';
  }

  /* ---------- Picker ---------- */
  var dialog = $('[data-picker]');
  var pickerSearch = $('[data-picker-search]');
  var pickerSort = $('[data-picker-sort]');
  var pickerList = $('[data-picker-list]');
  var pickerStatus = $('[data-picker-status]');
  var pickerBrands = $('[data-picker-brands]');
  var cache = {};

  function openPicker(slotId) {
    state.slot = slots().find(function (s) { return s.id === slotId; });
    state.brand = '';
    $('[data-picker-title]').textContent = 'Choose ' + state.slot.label.toLowerCase();
    pickerSearch.value = '';
    pickerSort.value = 'featured';
    pickerList.replaceChildren();
    pickerBrands.replaceChildren();
    pickerStatus.textContent = 'Finding available parts…';
    if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
    fetchProducts(state.slot).then(function (products) {
      state.products = products;
      renderBrands();
      renderPicker();
    });
  }

  function fetchProducts(slot) {
    if (cache[slot.query]) return Promise.resolve(cache[slot.query]);
    var products = [];
    function page(url) {
      return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var data = doc.querySelector('[data-tools-products]');
        var next = doc.querySelector('[data-tools-next]');
        try { products = products.concat(JSON.parse(data.textContent)); } catch (e) {}
        var nextUrl = next ? JSON.parse(next.textContent) : '';
        if (nextUrl && products.length < 150) return page(nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=ict-tools-products');
      });
    }
    var url = searchUrl + '?q=' + encodeURIComponent(slot.query) + '&type=product&section_id=ict-tools-products';
    return page(url).then(function () { cache[slot.query] = products; return products; }).catch(function () { return products; });
  }

  function renderBrands() {
    var counts = {};
    state.products.forEach(function (p) { if (p.vendor) counts[p.vendor] = (counts[p.vendor] || 0) + 1; });
    var brands = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });
    pickerBrands.replaceChildren();
    if (brands.length < 2) return;
    ['All'].concat(brands).forEach(function (name) {
      var b = el('button', 'ict-tp__brand' + ((name === 'All' && !state.brand) || name === state.brand ? ' is-active' : ''), name === 'All' ? 'All brands' : name + ' ' + counts[name]);
      b.type = 'button';
      b.dataset.brand = name === 'All' ? '' : name;
      pickerBrands.append(b);
    });
  }

  function renderPicker() {
    var q = pickerSearch.value.trim().toLowerCase();
    var words = q.split(/\s+/).filter(Boolean);
    var list = state.products.filter(function (p) {
      if (state.brand && p.vendor !== state.brand) return false;
      var hay = (p.title + ' ' + p.vendor + ' ' + p.type).toLowerCase();
      return words.every(function (w) { return hay.indexOf(w) > -1; });
    });
    if (pickerSort.value === 'price-asc') list.sort(function (a, b) { return a.price - b.price; });
    if (pickerSort.value === 'price-desc') list.sort(function (a, b) { return b.price - a.price; });
    pickerList.replaceChildren();
    var current = build()[state.slot.id];
    list.forEach(function (p) {
      var row = el('button', 'ict-tp__item' + (current && current.product === p.id ? ' is-current' : ''));
      row.type = 'button';
      row.dataset.pick = p.id;
      var media = el('span', 'ict-tp__media');
      if (p.image) { var img = el('img'); img.src = p.image; img.alt = ''; img.loading = 'lazy'; media.append(img); }
      row.append(media);
      var body = el('span', 'ict-tp__body');
      body.append(el('span', 'ict-tp__title', p.title));
      var price = el('span', 'ict-tp__price');
      price.append(el('strong', p.compare > p.price ? 'is-sale' : '', money(p.price)));
      if (p.compare > p.price) price.append(el('span', 'ict-tp__was', money(p.compare)));
      if (p.vendor) price.append(el('small', 'ict-tp__vendor', p.vendor));
      body.append(price);
      row.append(body);
      row.append(el('span', 'ict-tp__add', current && current.product === p.id ? '✓' : '+'));
      pickerList.append(row);
    });
    pickerStatus.textContent = list.length ? list.length + ' available' : (state.products.length ? 'No parts match your search.' : 'No parts in stock for this slot right now. Call 0976 544 1707 and we can source one.');
  }

  function pick(productId) {
    var p = state.products.find(function (x) { return String(x.id) === String(productId); });
    if (!p) return;
    var variant = (p.variants || []).find(function (v) { return v.available; }) || { id: p.variant, price: p.price };
    build()[state.slot.id] = { product: p.id, variant: variant.id, title: p.title, type: p.type, vendor: p.vendor, image: p.image, url: p.url, handle: p.handle, price: variant.price || p.price };
    save(state.tab);
    dialog.close();
    renderBuilder();
  }

  /* ---------- Cart, share, reset ---------- */
  // Adds items, updates the header count and opens Concept's cart drawer as the add-to-cart popup.
  function cartAdd(items) {
    return fetch(cartUrl + '/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add'); }); return fetch(cartUrl + '.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('cart-count').forEach(function (c) { var n = c.querySelector('[aria-hidden]') || c; n.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') setTimeout(function () { drawer.show(); }, 350);
        return cart;
      });
  }

  function addBuild() {
    var b = build();
    var items = slots().filter(function (s) { return b[s.id]; }).map(function (s) { return { id: b[s.id].variant, quantity: 1 }; });
    if (!items.length) return;
    var btn = $('[data-add]');
    var status = $('[data-status]');
    btn.disabled = true;
    status.textContent = 'Adding your parts…';
    cartAdd(items)
      .then(function () {
        status.innerHTML = '';
        status.append(document.createTextNode('Added to your cart. '));
        var a = el('a', '', 'View cart →'); a.href = cartUrl; status.append(a);
      })
      .catch(function (e) { status.textContent = e.message + '. Some parts may have just sold out — try changing them.'; })
      .finally(function () { btn.disabled = false; });
  }

  function shareBuild() {
    var b = build();
    var parts = slots().filter(function (s) { return b[s.id]; }).map(function (s) { return s.id + ':' + b[s.id].handle + ':' + b[s.id].variant; });
    var url = location.origin + location.pathname + '#' + state.tab + '=' + encodeURIComponent(parts.join(','));
    var status = $('[data-status]');
    if (!parts.length) { status.textContent = 'Add a part first, then share your build.'; return; }
    (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject())
      .then(function () { status.textContent = 'Link copied — anyone with it sees this build.'; })
      .catch(function () { window.prompt('Copy this link', url); });
  }

  function restoreFromHash() {
    var m = location.hash.match(/^#(pc|gaming)=(.+)$/);
    if (!m) return Promise.resolve();
    var mode = m[1];
    var parts = decodeURIComponent(m[2]).split(',');
    var next = {};
    return Promise.all(parts.map(function (part) {
      var bits = part.split(':');
      return fetch('/products/' + bits[1] + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var v = p.variants.find(function (x) { return String(x.id) === bits[2]; }) || p.variants[0];
        next[bits[0]] = { product: p.id, variant: v.id, title: p.title, type: p.type, vendor: p.vendor, image: p.featured_image, url: '/products/' + p.handle, handle: p.handle, price: v.price };
      }).catch(function () {});
    })).then(function () {
      state.builds[mode] = next;
      save(mode);
      history.replaceState(null, '', '#' + mode);
      state.tab = mode;
    });
  }

  /* ---------- Calculators ---------- */
  function num(sel) { var v = parseFloat($(sel).value); return isFinite(v) && v > 0 ? v : 0; }
  function duration(hours) {
    if (!isFinite(hours) || hours <= 0) return '–';
    var mins = Math.round(hours * 60);
    if (mins < 60) return mins + ' minutes';
    var h = Math.floor(mins / 60), m = mins % 60;
    return h + ' h' + (m ? ' ' + m + ' min' : '');
  }
  // UPS: same flow as the mobile app (equipment profile → suggested load, unless the load was typed in).
  var upsMode = 'desktop', upsManual = false;
  function upsPerCamera() { var r = $('[data-ups-res] [aria-pressed="true"]'); return r && r.dataset.res === '8' ? 12 : 10; }
  function upsSuggested() {
    if (upsMode === 'security') return Math.ceil((45 + (num('[data-ups-cams]') || 4) * upsPerCamera()) * 1.15);
    var on = $('[data-ups-profiles="' + upsMode + '"] [aria-pressed="true"]');
    return on ? Number(on.dataset.w) : 250;
  }
  function calcUps() {
    $$('[data-ups-mode]').forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.upsMode === upsMode)); });
    $$('[data-ups-form]').forEach(function (f) { f.hidden = f.dataset.upsForm !== upsMode; });
    $('[data-ups-sec-hint]').textContent = 'Uses about ' + upsPerCamera() + ' W per camera plus a typical NVR, one hard drive and 15% PoE overhead. Add monitors, switches or extra drives to the load below.';
    if (!upsManual) $('[data-ups-load]').value = upsSuggested();
    var load = num('[data-ups-load]'), volt = num('[data-ups-volt]') || 12, ah = num('[data-ups-ah]');
    var wh = volt * ah;
    var hours = load ? (wh * 0.8 * 0.85) / load : 0;
    $('[data-ups-out]').textContent = duration(hours);
    $('[data-ups-meta]').textContent = load ? 'for an estimated ' + load.toLocaleString() + ' W load' : '';
    $('[data-ups-wh]').textContent = wh ? Math.round(wh).toLocaleString() + ' Wh' : '–';
    var va = load / 0.6;
    var sizes = [650, 850, 1000, 1200, 1500, 2000, 3000, 5000, 6000, 10000];
    var rec = sizes.find(function (s) { return s >= va * 1.2; }) || Math.ceil(va * 1.2 / 1000) * 1000;
    $('[data-ups-va]').textContent = load ? rec.toLocaleString() + ' VA or larger' : '–';
  }
  function upsInput(e) {
    if (e.target.matches('[data-ups-load]')) upsManual = true;
    if (e.target.matches('[data-ups-cams]')) upsManual = false;
    calcUps();
  }
  function pressOne(btn) {
    $$('button', btn.parentNode).forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
  }

  // Solar: units from the bill (or meter readings) size the panels; the outage essentials size the battery and inverter.
  function calcSolar() {
    var cur = parseFloat($('[data-sol-cur]').value), prev = parseFloat($('[data-sol-prev]').value);
    if (isFinite(cur) && isFinite(prev)) $('[data-sol-units]').value = Math.max(0, cur - prev);
    var units = num('[data-sol-units]'), days = num('[data-sol-days]') || 30, sun = num('[data-sol-sun]') || 4.5, panelW = num('[data-sol-panel]') || 550;
    var daily = units / days;
    var panels = Math.max(1, Math.ceil(daily * 1000 / sun / 0.8 / panelW));
    var load = $$('[data-sol-apps] [aria-pressed="true"]').reduce(function (sum, b) { return sum + Number(b.dataset.w); }, 0) + num('[data-sol-other]');
    var battery = load * (num('[data-sol-backup]') || 8) / 1000 / 0.9 / 0.9;
    var inverter = Math.ceil(load * 1.25 / 100) / 10;
    $('[data-sol-month]').textContent = units ? Math.round(units).toLocaleString() + ' kWh' : '–';
    $('[data-sol-daily]').textContent = units ? daily.toFixed(1) + ' kWh' : '–';
    $('[data-sol-wh]').textContent = units ? daily.toFixed(1) + ' kWh / day' : '–';
    $('[data-sol-panels]').textContent = units ? panels + (panels === 1 ? ' panel' : ' panels') : '–';
    $('[data-sol-array]').textContent = units ? (panels * panelW / 1000).toFixed(1) + ' kW solar array' : 'Add your bill units';
    $('[data-sol-batt]').textContent = load ? battery.toFixed(1) + ' kWh' : '–';
    $('[data-sol-load]').textContent = load ? Math.round(load).toLocaleString() + ' W' : '–';
    $('[data-sol-inv]').textContent = load ? inverter.toFixed(1) + ' kW minimum inverter for ' + Math.round(load).toLocaleString() + ' W selected load' : 'Choose your outage essentials';
  }
  function solarInput(e) {
    if (e.target.matches('[data-sol-units]')) { $('[data-sol-cur]').value = ''; $('[data-sol-prev]').value = ''; }
    if (e.target.matches('[data-sol-file]')) {
      var file = e.target.files && e.target.files[0];
      if (file) {
        var img = $('[data-sol-photo-img]');
        if (img.src) URL.revokeObjectURL(img.src);
        img.src = URL.createObjectURL(file);
        $('[data-sol-photo]').hidden = false;
        $('[data-sol-cam-text]').textContent = 'Retake photo';
      }
      return;
    }
    calcSolar();
  }

  /* ---------- Storage calculator ---------- */
  // Typical main-stream bitrate (kbps) for H.264 at 25 fps, by megapixels.
  var BITRATE = { 2: 4096, 4: 6144, 5: 7168, 6: 8192, 8: 10240, 12: 14336 };
  var DRIVE_QUERIES = {
    cctv: '(product_type:"Video & Surveillance Drive" OR product_type:"Video & Surveillance Drives")',
    ssd: 'product_type:"Internal SSDs" AND -title:External AND -title:Portable',
    data: '(product_type:"Portable Drives HDDs" OR product_type:"Desktop External HDDs" OR product_type:"NAS & RAID Drives") AND -title:SSD'
  };
  var stoMode = 'cctv';
  var stoToken = 0;

  function gbText(gb) {
    if (!gb) return '–';
    if (gb >= 1000) return (gb / 1000).toFixed(gb >= 10000 ? 0 : 1).replace(/\.0$/, '') + ' TB';
    return Math.round(gb) + ' GB';
  }
  function capacityGB(text) {
    var m = String(text || '').match(/(\d+(?:\.\d+)?)\s?(TB|GB)\b/i);
    if (m) return parseFloat(m[1]) * (m[2].toUpperCase() === 'TB' ? 1000 : 1);
    m = String(text || '').match(/-(\d+)T\b/);
    return m ? Number(m[1]) * 1000 : 0;
  }
  // Cheapest ways to reach `need` GB with up to `maxCount` identical drives.
  function driveOptions(products, need, maxCount) {
    var best = {};
    products.forEach(function (p) {
      var variants = (p.variants || []).filter(function (v) { return v.available; });
      if (!variants.length) variants = [{ id: p.variant, title: '', price: p.price }];
      variants.forEach(function (v) {
        var cap = capacityGB(v.title) || capacityGB(p.title);
        if (!cap || !v.price) return;
        var count = Math.max(1, Math.ceil(need / cap));
        if (count > maxCount) return;
        var key = cap + 'x' + count;
        var total = v.price * count;
        if (!best[key] || total < best[key].total) best[key] = { product: p, variant: v.id, cap: cap, count: count, total: total };
      });
    });
    return Object.keys(best).map(function (k) { return best[k]; })
      .sort(function (a, b) { return a.total - b.total || a.count - b.count; })
      .slice(0, 3);
  }
  function renderDrivePicks(target, options, meta) {
    target.replaceChildren();
    if (!options.length) {
      target.append(el('p', 'ict-sto-empty', 'No single drive in stock covers this — call 0976 544 1707 and our team will spec it for you.'));
      return;
    }
    options.forEach(function (o, i) {
      var row = el('div', 'ict-sto-pick');
      var img = el('img'); img.src = o.product.image || ''; img.alt = ''; img.loading = 'lazy'; img.width = 48; img.height = 48;
      var body = el('div', 'ict-sto-pick__body');
      if (i === 0) body.append(el('span', 'ict-sto-pick__tag', 'Best value'));
      var title = el('a', 'ict-sto-pick__title', (o.count > 1 ? o.count + ' × ' : '') + o.product.title); title.href = o.product.url;
      body.append(title);
      body.append(el('span', 'ict-sto-pick__meta', money(o.total) + (meta ? ' · ' + meta(o) : '')));
      var add = el('button', 'ict-sto-pick__add', 'Add'); add.type = 'button';
      add.dataset.stoAdd = o.variant + ':' + o.count;
      add.setAttribute('aria-label', 'Add ' + (o.count > 1 ? o.count + ' × ' : '') + o.product.title + ' to cart');
      row.append(img, body, add);
      target.append(row);
    });
  }
  function stoStats(rows) {
    var dl = $('[data-sto-stats]');
    dl.replaceChildren();
    rows.forEach(function (r) { var d = el('div'); d.append(el('dt', '', r[0]), el('dd', '', r[1])); dl.append(d); });
  }
  function stoLinks(links) {
    var box = $('[data-sto-links]');
    box.replaceChildren();
    links.forEach(function (l) { var a = el('a', '', l[0]); a.href = searchUrl + '?q=' + encodeURIComponent(l[1]) + '&type=product'; box.append(a); });
  }
  function showPicks(groups) {
    var token = ++stoToken;
    var box = $('[data-sto-picks]');
    $('[data-sto-picks-label]').textContent = groups.length > 1 ? 'Recommended drives in stock' : 'Drives in stock';
    box.replaceChildren(el('p', 'ict-sto-empty', 'Checking stock…'));
    Promise.all(groups.map(function (g) { return fetchProducts({ query: g.query }); })).then(function (lists) {
      if (token !== stoToken) return;
      box.replaceChildren();
      groups.forEach(function (g, i) {
        if (groups.length > 1) box.append(el('p', 'ict-sto-group', g.label));
        var list = el('div', 'ict-sto-list');
        renderDrivePicks(list, driveOptions(lists[i], g.need, g.max), g.meta);
        box.append(list);
      });
    });
  }

  function calcCctv() {
    var cams = num('[data-sto-cams]') || 1, res = $('[data-sto-res]').value, codec = parseFloat($('[data-sto-codec]').value) || 0.5;
    var fps = num('[data-sto-fps]') || 15, activity = parseFloat($('[data-sto-rec]').value) || 1;
    var hours = Math.min(24, num('[data-sto-hours]') || 24), days = num('[data-sto-days]') || 30, bays = Number($('[data-sto-bays]').value) || 1;
    var kbps = (BITRATE[res] || 6144) * codec * Math.pow(fps / 25, 0.75);
    var perCamDay = kbps * 1000 / 8 * 3600 * hours * activity / 1e9;
    var dailyGB = perCamDay * cams;
    var needGB = dailyGB * days * 1.1;
    $('[data-sto-headline]').textContent = 'Hard drive space needed';
    $('[data-sto-out]').textContent = gbText(needGB);
    stoStats([
      ['Bitrate per camera', (kbps / 1024).toFixed(1) + ' Mbps'],
      ['Per camera per day', gbText(perCamDay)],
      ['All cameras per day', gbText(dailyGB)],
      ['Footage kept', days + ' days']
    ]);
    $('[data-sto-note]').textContent = 'Includes 10% for the recorder’s file system. Busy scenes, night-time noise and higher quality settings use more space; smart codecs save the most on quiet scenes. Use surveillance-grade drives (WD Purple) for 24/7 recording.';
    $$('[data-sto-presets="cctv"] button').forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.cams) === cams && b.dataset.res === res && Number(b.dataset.days) === days)); });
    stoLinks([['Surveillance drives', 'WD Purple surveillance hard drive'], ['NVR recorders', 'NVR']]);
    showPicks([{ query: DRIVE_QUERIES.cctv, need: needGB, max: bays, meta: function (o) { return '≈ ' + Math.floor(o.cap * o.count * 0.93 / dailyGB) + ' days'; } }]);
  }

  function calcPc() {
    var os = num('[data-sto-os]'), games = num('[data-sto-games]'), photos = num('[data-sto-photos]'), video = num('[data-sto-video]');
    var vq = parseFloat($('[data-sto-vq]').value) || 4, docs = num('[data-sto-docs]'), years = Number($('[data-sto-years]').value) || 2;
    var growth = Math.pow(1.25, years);
    var systemGB = (os + games * 90) * growth / 0.8;
    var mediaGB = (photos * 5 + video * vq + docs) * growth / 0.8;
    var split = mediaGB > 300;
    var ssdNeed = split ? systemGB : systemGB + mediaGB;
    var SSD = [256, 512, 1000, 2000, 4000], HDD = [1000, 2000, 4000, 6000, 8000, 12000, 16000];
    var ssdSize = SSD.find(function (s) { return s >= ssdNeed; }) || Math.ceil(ssdNeed / 1000) * 1000;
    var hddSize = split ? (HDD.find(function (s) { return s >= mediaGB; }) || Math.ceil(mediaGB / 1000) * 1000) : 0;
    $('[data-sto-headline]').textContent = 'Recommended storage';
    $('[data-sto-out]').textContent = gbText(ssdSize) + ' SSD' + (split ? ' + ' + gbText(hddSize) : '');
    stoStats([
      ['Windows, apps & games', gbText(os + games * 90)],
      ['Photos, video & files', gbText(photos * 5 + video * vq + docs)],
      ['Fast SSD (system & games)', gbText(ssdSize)],
      [split ? 'Data & backup drive' : 'Separate data drive', split ? gbText(hddSize) + ' HDD' : 'Not needed yet']
    ]);
    $('[data-sto-note]').textContent = 'Sized for ' + years + (years > 1 ? ' years' : ' year') + ' of growth (about 25% a year) while keeping 20% free so Windows stays fast. Keep a second copy of photos on an external drive.';
    $$('[data-sto-presets="pc"] button').forEach(function (b) {
      b.setAttribute('aria-pressed', String(['os', 'games', 'photos', 'video', 'docs'].every(function (k) { return Number(b.dataset[k]) === num('[data-sto-' + k + ']'); }) && Number(b.dataset.vq) === vq));
    });
    stoLinks([['Internal SSDs', 'SSD'], ['External hard drives', 'external hard drive']]);
    var groups = [{ label: 'Fast SSD', query: DRIVE_QUERIES.ssd, need: ssdNeed, max: 1 }];
    if (split) groups.push({ label: 'Data & backup drive', query: DRIVE_QUERIES.data, need: mediaGB, max: 1 });
    showPicks(groups);
  }

  function calcStorage() {
    $$('[data-sto-mode]').forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.stoMode === stoMode)); });
    $$('[data-sto-form]').forEach(function (f) { f.hidden = f.dataset.stoForm !== stoMode; });
    if (stoMode === 'cctv') calcCctv(); else calcPc();
  }
  var calcStorageSoon = (function () { var t; return function () { clearTimeout(t); t = setTimeout(calcStorage, 200); }; })();

  /* ---------- Events ---------- */
  root.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-tab]'))) return setTab(t.dataset.tab);
    if ((t = e.target.closest('[data-choose]'))) return openPicker(t.dataset.choose);
    if ((t = e.target.closest('[data-remove]'))) { delete build()[t.dataset.remove]; save(state.tab); return renderBuilder(); }
    if ((t = e.target.closest('[data-pick]'))) return pick(t.dataset.pick);
    if ((t = e.target.closest('[data-brand]'))) { state.brand = t.dataset.brand; renderBrands(); return renderPicker(); }
    if (e.target.closest('[data-picker-close]')) return dialog.close();
    if (e.target.closest('[data-add]')) return addBuild();
    if (e.target.closest('[data-share]')) return shareBuild();
    if (e.target.closest('[data-reset]')) { state.builds[state.tab] = {}; save(state.tab); $('[data-status]').textContent = ''; return renderBuilder(); }
    if (e.target.closest('[data-to-ups]')) {
      var w = Number(root.dataset.loadWatts) || 0;
      if (w) { $('[data-ups-load]').value = w + 60; upsManual = true; }
      return setTab('ups');
    }
    if ((t = e.target.closest('[data-ups-mode]'))) { upsMode = t.dataset.upsMode; upsManual = false; return calcUps(); }
    if ((t = e.target.closest('[data-ups-profiles] button, [data-ups-res] button'))) { pressOne(t); upsManual = false; return calcUps(); }
    if ((t = e.target.closest('[data-sol-apps] button'))) { t.setAttribute('aria-pressed', String(t.getAttribute('aria-pressed') !== 'true')); return calcSolar(); }
    if ((t = e.target.closest('[data-sto-mode]'))) { stoMode = t.dataset.stoMode; return calcStorage(); }
    if ((t = e.target.closest('[data-sto-presets="cctv"] button'))) {
      $('[data-sto-cams]').value = t.dataset.cams; $('[data-sto-res]').value = t.dataset.res; $('[data-sto-days]').value = t.dataset.days;
      return calcStorage();
    }
    if ((t = e.target.closest('[data-sto-presets="pc"] button'))) {
      ['os', 'games', 'photos', 'video', 'vq', 'docs'].forEach(function (k) { $('[data-sto-' + k + ']').value = t.dataset[k]; });
      return calcStorage();
    }
    if ((t = e.target.closest('[data-sto-add]'))) {
      var parts = t.dataset.stoAdd.split(':');
      t.disabled = true; t.textContent = '…';
      return cartAdd([{ id: Number(parts[0]), quantity: Number(parts[1]) || 1 }])
        .then(function () { t.textContent = 'Added ✓'; t.classList.add('is-added'); })
        .catch(function () { t.textContent = 'Add'; t.disabled = false; });
    }
  });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  pickerSearch.addEventListener('input', renderPicker);
  pickerSort.addEventListener('change', renderPicker);
  $('[data-panel="ups"]').addEventListener('input', upsInput);
  $('[data-panel="solar"]').addEventListener('input', solarInput);
  $('[data-panel="solar"]').addEventListener('change', function (e) { if (e.target.matches('[data-sol-file]')) solarInput(e); });
  $$('[data-panel="storage"] input, [data-panel="storage"] select').forEach(function (i) { i.addEventListener('input', calcStorageSoon); });
  window.addEventListener('hashchange', function () { var h = location.hash.slice(1).split('=')[0]; if (h && h !== state.tab) setTab(h, false); });

  restoreFromHash().then(function () {
    var h = location.hash.slice(1).split('=')[0];
    setTab(h || state.tab, false);
  });
})();

/* Keep the chosen preset chip in view inside the horizontal chip row */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('.ict-calc__chips button');
  if (b) b.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
});
